export default __webpack_public_path__ + "static/media/qna.95845000.png";